import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useIdleTimer as useIdlTimer } from "react-idle-timer";

import { setIdleTimer } from "Layout/slice";

export const useIdleTimer = () => {
  const dispatch = useDispatch();
  const [remainingTime, setRemaining] = useState(0);

  const onIdle = () => {
    dispatch(setIdleTimer(true));
  };

  const onActive = () => {
    dispatch(setIdleTimer(false));
  };

  const { getRemainingTime } = useIdlTimer({
    onIdle,
    onActive,
    timeout: 60000,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  return remainingTime;
};
